import { Component } from 'react';

import Account from './account/Account';
import BillingLoggedInPickup from './billing/BillingLoggedInPickup';
import BillingLoggedInShip from './billing/BillingLoggedInShip';
import BillingNotLoggedInPickup from './billing/BillingNotLoggedInPickup';
import BillingNotLoggedInShip from './billing/BillingNotLoggedInShip';
import CustomerLoggedInPickup from './customer/CustomerLoggedInPickup';
import CustomerLoggedInShip from './customer/CustomerLoggedInShip';
import CustomerNotLoggedInPickup from './customer/CustomerNotLoggedInPickup';
import CustomerNotLoggedInShip from './customer/CustomerNotLoggedInShip';
import Payment from './payment/Payment';
import Process from './process/Process';

class EditStep extends Component {
  constructor(props) {
    super(props);
    const { clubSignup } = props;
    this.state = {
      orderDeliveryMethod:
        (clubSignup && clubSignup.orderDeliveryMethod) || 'Ship'
    };
  }

  handlePickup = () => {
    this.setState({ orderDeliveryMethod: 'Pickup' });
  };

  handleShip = () => {
    this.setState({ orderDeliveryMethod: 'Ship' });
  };

  render() {
    const { step, onEdit, clubSignup, customer, club } = this.props;
    const { orderDeliveryMethod } = this.state;
    switch (step) {
      case 'customer':
        if (orderDeliveryMethod === 'Ship') {
          if (customer && clubSignup.customerId) {
            return <CustomerLoggedInShip onPickup={this.handlePickup} />;
          }
          return <CustomerNotLoggedInShip onPickup={this.handlePickup} />;
        }
        if (customer && clubSignup.customerId) {
          return <CustomerLoggedInPickup onShip={this.handleShip} />;
        }
        return <CustomerNotLoggedInPickup onShip={this.handleShip} />;
      case 'billing': {
        if (orderDeliveryMethod === 'Ship') {
          if (customer && clubSignup.customerId) {
            return (
              <BillingLoggedInShip
                clubSignup={clubSignup}
                club={club}
                onEdit={onEdit}
              />
            );
          }
          return (
            <BillingNotLoggedInShip
              clubSignup={clubSignup}
              club={club}
              onEdit={onEdit}
            />
          );
        }
        if (customer && clubSignup.customerId) {
          return (
            <BillingLoggedInPickup
              clubSignup={clubSignup}
              club={club}
              onEdit={onEdit}
            />
          );
        }
        return (
          <BillingNotLoggedInPickup
            clubSignup={clubSignup}
            club={club}
            onEdit={onEdit}
          />
        );
      }
      case 'account':
        return <Account onEdit={onEdit} club={club} />;
      case 'payment':
        return <Payment clubSignup={clubSignup} club={club} onEdit={onEdit} />;
      case 'complete':
        return <Process club={club} />;
      default:
        throw new Error('Invalid Step');
    }
  }
}

export default EditStep;
